import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import ProductCard from "../../components/ProductCard/ProductCard";
import ProductGridSkeleton from "../../components/ProductGridSkeleton/ProductGridSkeleton";
import "./Shop.scss";

function Shop() {
  const [shopProducts, setShopProducts] = useState(null);

  useEffect(() => {
    const productsCollectionRef = collection(db, "products");
    const getProductData = async () => {
      const data = await getDocs(productsCollectionRef);
      let results = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      const available = results.filter((item) => {
        return item.available === "Is Available";
      });
      // console.log(results);
      setShopProducts(available);
      document.title = "Shop - Branded Jewellery UK ";
    };
    getProductData();
  }, []);

  if (shopProducts === null) {
    return (
      <div>
        <ProductGridSkeleton className="shop" />
      </div>
    );
  }

  return (
    <div>
      <div className="shop">
        {shopProducts.map((product) => {
          return <ProductCard data={product} key={product.id} />;
        })}
      </div>
    </div>
  );
}

export default Shop;
